import { type IconTypes } from '@ics-portal/guardian';
import { SurveyStatus } from '@gql/graphql';

interface PssStatusPresentation {
    icon: IconTypes;
    label: string;
}

const PSS_STATUS_PRESENTATIONS: Record<SurveyStatus, PssStatusPresentation> = {
    [SurveyStatus.Completed]: {
        icon: 'check_circle',
        label: 'Completed',
    },
    [SurveyStatus.Declined]: {
        icon: 'block',
        label: 'Declined',
    },
    [SurveyStatus.Draft]: {
        icon: 'chronic',
        label: 'Draft',
    },
    [SurveyStatus.Readyforapproval1]: {
        icon: 'send_money',
        label: 'Sent for initial approval',
    },
    [SurveyStatus.Readyforapproval2]: {
        icon: 'published_with_changes',
        label: 'Sent for final approval',
    },
};

export function getPssStatusPresentation(
    status?: SurveyStatus,
): PssStatusPresentation {
    if (!status) {
        return {
            icon: 'counter_0',
            label: 'Not started',
        };
    }

    return PSS_STATUS_PRESENTATIONS[status];
}
